import { Box, Flex, Text } from '@chakra-ui/react'

import { useReportingI18n } from '../i18n'
import type { NumberData } from '../types'
import { formatDuration } from '../utils/formatter'

interface NumberComparisonTableProps {
  data: NumberData[]
}

const NumberComparisonTable = ({ data }: NumberComparisonTableProps) => {
  const { text } = useReportingI18n()

  const cellTextStyle = {
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: '500',
    lineHeight: '16px',
  }

  return (
    <Box
      width="100%"
      border="1px solid"
      borderColor="border.default"
      borderRadius="10px"
      overflow="hidden"
    >
      <Flex
        display="flex"
        padding="8px 16px"
        alignItems="center"
        gap="16px"
        alignSelf="stretch"
        borderBottom="1px solid"
        borderColor="border.default"
        bg="bg.subtle"
      >
        <Box
          display="flex"
          padding="4px 0"
          flexDirection="column"
          justifyContent="center"
          alignItems="flex-start"
          flex="1 0 0"
        >
          <Text {...cellTextStyle} color="fg.default">
            {text('numberComparisonTable.columns.name', 'Phone Number Name')}
          </Text>
        </Box>
        <Box
          display="flex"
          padding="4px 0"
          flexDirection="column"
          justifyContent="center"
          alignItems="flex-start"
          flex="1 0 0"
        >
          <Text {...cellTextStyle} color="fg.default">
            {text('numberComparisonTable.columns.number', 'Phone Number')}
          </Text>
        </Box>
        <Box
          display="flex"
          padding="4px 0"
          flexDirection="column"
          justifyContent="center"
          alignItems="flex-start"
          flex="1 0 0"
        >
          <Text {...cellTextStyle} color="fg.default">
            {text(
              'numberComparisonTable.columns.inboundCalls',
              'Inbound Calls',
            )}
          </Text>
        </Box>
        <Box
          display="flex"
          padding="4px 0"
          flexDirection="column"
          justifyContent="center"
          alignItems="flex-start"
          flex="1 0 0"
        >
          <Text {...cellTextStyle} color="fg.default">
            {text('numberComparisonTable.columns.avgDuration', 'Avg Duration')}
          </Text>
        </Box>
      </Flex>

      <Box>
        {data.map((row, index) => (
          <Flex
            key={row.number}
            display="flex"
            padding="8px 16px"
            alignItems="center"
            gap="16px"
            alignSelf="stretch"
            borderBottom={index < data.length - 1 ? '1px solid' : 'none'}
            borderColor="border.default"
            _hover={{ bg: 'bg.subtle' }}
          >
            <Box
              display="flex"
              padding="4px 0"
              flexDirection="column"
              justifyContent="center"
              alignItems="flex-start"
              flex="1 0 0"
            >
              <Text {...cellTextStyle} color="fg.default">
                {row.name}
              </Text>
            </Box>
            <Box
              display="flex"
              padding="4px 0"
              flexDirection="column"
              justifyContent="center"
              alignItems="flex-start"
              flex="1 0 0"
            >
              <Text {...cellTextStyle} color="fg.muted">
                {row.displayNumber}
              </Text>
            </Box>
            <Box
              display="flex"
              padding="4px 0"
              flexDirection="column"
              justifyContent="center"
              alignItems="flex-start"
              flex="1 0 0"
            >
              <Text {...cellTextStyle} color="fg.info">
                {row.inboundCalls.toLocaleString()}
              </Text>
            </Box>
            <Box
              display="flex"
              padding="4px 0"
              flexDirection="column"
              justifyContent="center"
              alignItems="flex-start"
              flex="1 0 0"
            >
              <Text {...cellTextStyle} color="fg.muted">
                {formatDuration(row.averageDuration)}
              </Text>
            </Box>
          </Flex>
        ))}
      </Box>
    </Box>
  )
}

export default NumberComparisonTable
